export default __webpack_public_path__ + "static/media/04.909e20c1.jpg";